// extracted by mini-css-extract-plugin
export var focus = "link-module--focus--41188";
export var link = "link-module--link--4a60f";